import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import * as React from 'react';

import { AdBannerMicrofrontendContainer } from '../AdBannerMicrofrontendContainer';
import { useFooterParameters } from './hooks/useFooterParameters';

interface IAdBannerMicrofrontendFooterContainerProps {
  manifest: IMicrofrontendManifest;
  onStub?: () => void;
  onError?: () => void;
  onClose?: () => void;
}

/**
 * Place-контейнер футерного баннера: поставляет параметры места и рендерит generic-контейнер.
 */
export const AdBannerMicrofrontendFooterContainer: React.FC<IAdBannerMicrofrontendFooterContainerProps> = ({
  manifest,
  onStub,
  onError,
  onClose,
}) => {
  const parameters = useFooterParameters();

  return (
    <AdBannerMicrofrontendContainer
      manifest={manifest}
      parameters={parameters}
      onStub={onStub}
      onError={onError}
      onClose={onClose}
    />
  );
};
